<nb-card>
  <nb-card-header
    ><span class="title">{{ title }}</span>
    <nb-icon class="close" icon="close-outline" (click)="close()"></nb-icon
  ></nb-card-header>
  <nb-card-body>
    <div class="role-select" *ngIf="careHomes | async as careHomes">
      <nb-select-label>Care Home</nb-select-label>
      <nb-select
        [formControl]="form.controls.targetCareHomeId"
        fullWidth
        id="careHome"
      >
        <nb-option
          *ngFor="let careHome of careHomes"
          [value]="careHome.careHomeId"
          >{{ careHome.careHomeFullName }}</nb-option
        >
      </nb-select>
    </div>
    <div class="role-select">
      <nb-select-label>Comments</nb-select-label>
      <textarea
        [formControl]="form.controls.comments"
        autofocus
        fullWidth
        id="comments"
        maxlength="5000"
        nbInput
        placeholder="Comments"
        rows="5"
      >
      </textarea>
    </div>
    <div class="date-inputs">
      <div class="role-select">
        <nb-select-label>Start date</nb-select-label>
        <input
          [formControl]="form.controls.dateStart"
          [nbDatepicker]="dateFromPicker"
          autocomplete="off"
          id="dateFrom"
          nbInput
        />
        <nb-datepicker #dateFromPicker></nb-datepicker>
      </div>

      <div class="role-select">
        <nb-select-label>End date</nb-select-label>
        <input
          [formControl]="form.controls.dateEnd"
          [nbDatepicker]="dateToPicker"
          autocomplete="off"
          id="dateTo"
          nbInput
        />
        <nb-datepicker #dateToPicker></nb-datepicker>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button (click)="save()" [disabled]="form.invalid" class="btn btn-success">
      Save
    </button>
    <button (click)="close()" class="btn btn-danger">Cancel</button>
  </nb-card-footer>
</nb-card>
